import React, { memo } from 'react';
import { Box } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { AlyceTheme, SanitizedHTML } from '@alycecom/ui';

export interface ITangoCardInstructionsProps {
  content?: string;
}

const useStyles = makeStyles<AlyceTheme>(({ palette }) => ({
  text: {
    color: palette.grey.main,
    fontSize: 16,
  },
}));

const TangoCardInstructions = ({ content = '' }: ITangoCardInstructionsProps): JSX.Element => {
  const classes = useStyles();
  return (
    <Box my={[2, 3]} maxWidth={500} mx="auto">
      <SanitizedHTML className={classes.text} html={content || ''} />
    </Box>
  );
};

export default memo(TangoCardInstructions);
